import { format, getDay, isSameDay } from 'date-fns';

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export function getEventDateStr(eventDate: EventDateFragment) {
  if (eventDate) {
    const start = new Date(eventDate.startDate!);
    const end = new Date(eventDate.endDate!);

    const startTime = format(start, 'hamm').replace('00', '').toLowerCase();
    const endTime = format(end, 'hamm').replace('00', '').toLowerCase();
    if (isSameDay(start, end)) {
      return `${days[getDay(start)]} ${format(start, 'do MMMM')} ${startTime} to ${endTime}`;
    }
    return `${days[getDay(start)]} ${format(start, 'do MMMM')} ${startTime} to ${days[getDay(end)]} ${format(
      end,
      'do MMMM',
    )} ${endTime}`;
  }
  return null;
}
